import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  fetchUserById,
  updateUser,
  resetStatus,
} from "../../store/slices/userSlice";
import StatusPopup from "../../components/popups/StatusPopup";
import EditPresnolDetail from "../../components/form/EditPresnolDetail";
import EditPayTaxes from "../../components/form/EditPayTaxes";
import EditAction from "../../components/form/EditAction";

const ProfilePage = () => {
  const dispatch = useAppDispatch();

  const {
    user,
    role,
    isSuccess,
    errorMessage,
    loading: isUpdating,
  } = useAppSelector((s) => s.user);

  const EDIT_KEY = `profilePage_${user?.id}`;

  const {
    countries = [],
    states = [],
    cities = [],
  } = useAppSelector((state) => state.location || {});

  const selectedUser = useAppSelector(
    (s) => s.user.entityByKey[EDIT_KEY] || null,
  );
  const isInitialLoading = useAppSelector(
    (s) => s.user.entityLoadingByKey[EDIT_KEY] || false,
  );

  const [profileFormData, setProfileFormData] = useState({});

  useEffect(() => {
    dispatch(resetStatus());
    if (user?.id) {
      dispatch(fetchUserById({ id: user?.id, key: EDIT_KEY }));
    }
    // Cleanup on unmount
    return () => dispatch(resetStatus());
  }, [user?.id, dispatch, EDIT_KEY]);

  useEffect(() => {
    if (selectedUser) {
      setProfileFormData(selectedUser);
    }
  }, [selectedUser]);

  useEffect(() => {
    if (isSuccess) {
      const timer = setTimeout(() => {
        dispatch(resetStatus());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSuccess, dispatch]);

  const handleDataChange = (updatedData) => {
    setProfileFormData((prev) => ({ ...prev, ...updatedData }));
  };

  const handlePopupClose = () => {
    dispatch(resetStatus());
  };

  const handleUpdate = () => {
    if (!user?.id || !profileFormData) return;

    const formData = new FormData();
    formData.append("name", profileFormData.name || "");
    formData.append("email", profileFormData.email || "");
    formData.append("phone", profileFormData.phone || "");
    formData.append(
      "addressLine1",
      profileFormData.addressLine1 ||
        profileFormData.addressLine ||
        profileFormData.address ||
        "",
    );
    formData.append(
      "cityId",
      profileFormData.cityId || profileFormData.CityId || "",
    );
    formData.append("postalCode", profileFormData.postalCode || "");

    if (profileFormData.file) {
      formData.append("file", profileFormData.file);
    }

    dispatch(updateUser({ id: Number(user?.id), data: formData }));
  };

  // Agar initial data load ho raha hai toh full page loader
  if (isInitialLoading && !selectedUser) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading</span>
        </div>
        <h5 className="ms-3 mb-0">Fetching Profile Data</h5>
      </div>
    );
  }

  return (
    <>
      <div className={isUpdating ? "opacity-50 pointer-events-none" : ""}>
        <EditAction
          clientData={profileFormData}
          onUpdate={handleUpdate}
          isLoading={isUpdating} // Button par loader dikhane ke liye
          isProfile={true}
        />
        <div>
          <EditPresnolDetail
            clientData={profileFormData}
            onDataChange={handleDataChange}
            countries={countries}
            states={states}
            cities={cities}
          />
          {role !== "SuperAdmin" && (
            <EditPayTaxes
              clientData={profileFormData}
              onDataChange={handleDataChange}
              showTaxReminder={role === "Company"}
            />
          )}
        </div>
      </div>

      <StatusPopup
        key={`${Boolean(errorMessage || isSuccess)}-${isSuccess ? "success" : "error"}`}
        show={Boolean(errorMessage || isSuccess)}
        type={isSuccess ? "success" : "error"}
        title={isSuccess ? "Success" : "Error"}
        message={
          isSuccess
            ? "Profile updated successfully."
            : Array.isArray(errorMessage)
              ? errorMessage.join(", ")
              : errorMessage
        }
        handleClose={handlePopupClose}
      />
    </>
  );
};

export default ProfilePage;
